import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import moment from 'moment'

import styles from './PublishDate.module.scss'

export const PublishDate = ({ date, className }) => {
  const classes = classnames(
    styles.publishDate,
    { [`${className}`]: className }
  )

  return (
    <time dateTime={date} className={classes}>{moment(date, 'YYYY-MM-DD').format('MMMM Do, YYYY')}</time>
  )
}

PublishDate.propTypes = {
  date: PropTypes.string.isRequired,
  className: PropTypes.string,
}
